import StepId from "@/model/progress/StepId"

const FinishView = () => import("@/views/FinishView")

export default [
    {
        name: "finish",
        path: "/finish",
        component: FinishView,
        meta: {
            public: true,
            step: StepId.COMPLETE,
            stepper: false
        },
    },
    {
        name: "finishWithType",
        path: "/finish/:type",
        component: FinishView,
        meta: {
            public: true,
            step: StepId.COMPLETE,
            stepper: false
        },
    }
]
